import { component } from 'picoapp';
import getClosest from '../../utils/getClosest';
import getSiblings from '../../utils/getSiblings';
const delegate = require('delegate');

class AccordionNav {
  constructor(el, ctx) {
    this.el = el;
    this.ctx = ctx;
    this.init(el);
    this.bindEvents();
  }

  init(el) {
    this.el = el;
    this.mainOptions = el.querySelectorAll(':scope > .has-submenu');

    // set the current option as expanded
    const currentOption = el.querySelector(':scope > .auto-expand > a');
    this.toggleItem(currentOption);
  }

  bindEvents() {
    delegate(
      this.el,
      '.has-submenu > a',
      'click',
      (e) => {
        e.preventDefault();
        this.toggleItem(e.delegateTarget);
      },
      false
    );
  }

  toggleItem(el) {
    const parentNode = getClosest(el, '.Nav__item');

    if (!parentNode) return;

    parentNode.classList.toggle('is-open');
    var optionsArray = Array.prototype.slice.call(getSiblings(parentNode));
    var filteredArray = optionsArray.filter((item) => !item.isEqualNode(parentNode));

    filteredArray.forEach((el) => {
      el.classList.remove('is-open');
    });
  }
}

// export default MainNav;
export default component((node, ctx) => {
  new AccordionNav(node, ctx);
});
